import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  Expenses,
  NewExpense,
  PaymentStatus,
  SelectedUserExpenses,
  UpdateExpense,
} from './state/expenses.state';

@Injectable({
  providedIn: 'root',
})
export class ExpenseService {
  private apiServerHost: string = environment.apiServerHost;
  constructor(private httpClient: HttpClient) {}

  createNewExpense(userId: number, newExpense: NewExpense): Observable<void> {
    return this.httpClient.post<void>(
      `${this.apiServerHost}/cm-services/api/v1/expense-service/users/${userId}/expenses`,
      newExpense,
    );
  }

  getExpenses(userId: number): Observable<Expenses[]> {
    return this.httpClient.get<Expenses[]>(
      `${this.apiServerHost}/cm-services/api/v1/expense-service/users/${userId}/expenses`,
    );
  }

  getExpenseTransactions(
    userId: number,
    selectedUserId: number,
    status: PaymentStatus,
  ): Observable<SelectedUserExpenses[]> {
    return this.httpClient.get<SelectedUserExpenses[]>(
      `${this.apiServerHost}/cm-services/api/v1/expense-service/users/${userId}/expenses/${selectedUserId}?status=${status}`,
    );
  }

  updateExpenseTransaction(
    userId: number,
    expenseId: number,
    payload: UpdateExpense,
  ): Observable<void> {
    return this.httpClient.post<void>(
      `${this.apiServerHost}/cm-services/api/v1/expense-service/users/${userId}/expenses/${expenseId}`,
      payload,
    );
  }

  deleteExpenseTransaction(
    userId: number,
    expenseId: number,
  ): Observable<void> {
    return this.httpClient.delete<void>(
      `${this.apiServerHost}/cm-services/api/v1/expense-service/users/${userId}/expenses/${expenseId}`,
    );
  }
}
